<div class="cta-link" [class.cta-link__active]="active" [translate]="'eos-tv-shop-ii.lbl.terms-and-conditions'"></div>
